<template>
  <section>
    <div
      id="container-scroller"
      class="container-scroller overflow-auto flex-shrink-1 position-relative"
    >
      <Header />
      <Sidebar />
      <div class="container-fluid page-body-wrapper">
        <div class="main-panel">
          <div
            id="main-container"
            class="content-wrapper p-0 pt-sm-2 pl-sm-2"
            style="overflow: hidden"
          >
            <div class="card p-0 px-md-4 fullHeight">
              <div class="card-body p-0">
                <div v-if="$te(`routes.${pageName}`)" class="pt-2 pt-md-5">
                  <router-link
                    v-if="needShowAllDevicesLink"
                    class="d-flex text-muted px-3 px-md-5"
                    :to="{ name: 'Boxes' }"
                  >
                    <i class="mdi mdi-chevron-left btn-icon-prepend"></i>
                    {{ $t('addBox.allDevices') }}
                  </router-link>
                  <div class="row page-header pt-3 px-3 px-md-5">
                    {{ $t(`routes.${pageName}`) }}
                  </div>
                </div>

                <slot />
              </div>
            </div>
          </div>

          <!-- content wrapper ends -->
          <Footer />
        </div>
        <!-- main panel ends -->
      </div>
      <!-- page-body-wrapper ends -->
    </div>
  </section>
</template>

<script>
import Header from './partials/Header';
import Sidebar from './partials/Sidebar';
import Footer from './partials/Footer';

export default {
  name: 'Layout',
  components: {
    Header,
    Sidebar,
    Footer,
  },
  computed: {
    pageName() {
      const routName = this.$route.name;
      if (routName) {
        return routName;
      }
      return null;
    },
    // -------- удалить после добавления метаданных в роутере --------
    needShowAllDevicesLink() {
      return this.$route.name == 'SettingsAddBox';
    },

    // -------- end --------
  },
};
</script>

<style scoped>
.container-fluid {
  padding: 0px;
}
.fullHeight {
  min-height: 100%;
}

.page-header {
  font-style: normal;
  font-weight: normal;
  font-size: 30px;
  line-height: 130%;
  color: #ffffff;
  margin: 0px;
  position: relative;
  z-index: 2;
}
</style>
